var _g, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAddDocument = function SvgAddDocument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    viewBox: "0 0 350 350",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1111",
    "data-name": "Group 1111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1110",
    "data-name": "Group 1110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1109",
    "data-name": "Group 1109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3577",
    "data-name": "Path 3577",
    d: "M232.89,171.42a9.32,9.32,0,0,0-9.32-9.32h-96a9.33,9.33,0,0,0,0,18.65h96a9.33,9.33,0,0,0,9.33-9.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3602",
    "data-name": "Path 3602",
    d: "M127.54,237.29a9.32,9.32,0,0,0,0,18.64h58.32a9.32,9.32,0,0,0,0-18.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3579",
    "data-name": "Path 3579",
    d: "M142.75,295.22H104.27a22.67,22.67,0,0,1-23-22.26V77a22.67,22.67,0,0,1,23-22.27H245.73a22.67,22.67,0,0,1,23,22.27v68.46a11.51,11.51,0,0,0,23,0V77c0-24.56-20.64-44.53-46-44.53H104.27c-25.38,0-46,20-46,44.53V273c0,24.55,20.64,44.53,46,44.53h38.48a11.14,11.14,0,0,0,.78-22.26h-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3581",
    "data-name": "Path 3581",
    d: "M223.56,88.43h-96a9.33,9.33,0,0,0,0,18.65h96a9.33,9.33,0,0,0,0-18.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3601",
    "data-name": "Path 3601",
    d: "M223.56,124.81h-96a9.33,9.33,0,0,0,0,18.65h96a9.33,9.33,0,0,0,0-18.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3603",
    "data-name": "Path 3603",
    d: "M232.89,209.32a9.32,9.32,0,0,0-9.32-9.32h-96a9.33,9.33,0,0,0,0,18.65h96a9.33,9.33,0,0,0,9.33-9.32Z"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3597",
    "data-name": "Path 3597",
    d: "M301.08,269.06H273.7V241.68a10,10,0,1,0-19.91,0v27.38H226.41a10,10,0,0,0,0,19.91h27.38v27.38a10,10,0,0,0,19.91,0V289h27.38a10,10,0,1,0,0-19.91Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add_document.6710a1a8.svg";
export { ForwardRef as ReactComponent };